module.exports = __webpack_public_path__ + "images/big_doubt.9755565c586ec0eca325.jpg";